<div class="flex-column-s flex"
     [class.flex-column]="component.variant === 'image-above-text'"
     *ngIf="component">
    <div class="pos-relative overflow-hidden"
         [ngClass]="component.variant === 'image-above-text' ? 'c-12 ratio-3-1 ratio-4-5-s' : 'c-9 c-8-l c-7-m c-12-s ratio-4-3'">

        <ng-template ifSize="!S">
            <shell></shell>

            <href class="fill"
                  [link]="component.defaultImageUrl"
                  *ngIf="activeImages[0]">
                <img class="fill"
                     [ngClass]="selectedColorIndex === undefined ? 'z-1' : 'z-3'"
                     [image]="activeImages[0]">
            </href>
            <ng-container *ngIf="component.contentVariant === contentVariant.video">
                <vimeo-player class="rf z-2"
                              [video-id]="component.contentVideoId"
                              [background]="true"
                              [loop]="true"
                              *ngIf="component.contentVideoProvider === contentVideoProvider.vimeo">
                </vimeo-player>

                <youtube-player class="rf z-2"
                                [video-id]="component.contentVideoId"
                                *ngIf="component.contentVideoProvider === contentVideoProvider.youtube">
                </youtube-player>
            </ng-container>
        </ng-template>

        <ng-container *ifSize="'S'">
            <swiper class="rf z-4"
                    [pagination]="true"
                    [allowTouchMove]="true"
                    (afterInit)="onAfterInit($event)"
                    #swiper>

                <ng-container *ngFor="let slide of activeImages; let i = index">
                    <ng-template swiperSlide>
                        <img class="rf z-1"
                             [image]="slide">

                        <ng-container
                                      *ngIf="component.contentVariant === contentVariant.video && (selectedColorIndex === undefined || i === 1)">
                            <vimeo-player class="rf z-2"
                                          [video-id]="component.contentVideoId"
                                          [background]="true"
                                          [loop]="true"
                                          *ngIf="component.contentVideoProvider === contentVideoProvider.vimeo">
                            </vimeo-player>

                            <youtube-player class="rf z-2"
                                            [video-id]="component.contentVideoId"
                                            *ngIf="component.contentVideoProvider === contentVideoProvider.youtube">
                            </youtube-player>
                        </ng-container>
                    </ng-template>
                </ng-container>

            </swiper>

            <swiper-dots class="pos-absolute bottom-0 left-50 m-l-2 m-b-2 z-5"
                         [swiperRef]="swiper"
                         *ngIf="activeImages?.length > 1"></swiper-dots>
        </ng-container>

        <div class="bg-col-w p-a-5 p-a-2-m p-a-2-s pos-absolute top-50-x top-50-l bottom-10-m bottom-10-s left-10 left-50-m left-50-s z-4"
             *ngIf="!activeColourData && component?.initialTitle">
            <p class="hero center-s"
               *iCms="'initialTitle' of component"></p>
        </div>

        <ng-container *ifSize="'XL'">
            <div class="bg-col-w p-t-10 p-b-10 p-l-10 p-r-12 pos-absolute top-50 left-10 z-4 overflow-wrap"
                 *ngIf="activeColourData?.label">

                <p class="hero">{{ activeColourData?.label }}</p>

                <p class="p1 m-t-5"
                   *ngIf="activeColourData?.copy">{{ activeColourData?.copy }}</p>

                <button class="button m-t-5"
                        type="button"
                        *ngIf="activeColourData?.ctaCopy">
                    <span>{{ activeColourData?.ctaCopy }}</span>
                </button>
            </div>
        </ng-container>

        <ng-container *ifSize="'MS'">
            <div class="bg-col-w p-a-2 pos-absolute z-1 bottom-10 left-50 z-4"
                 *ngIf="activeColourData?.label">
                <p class="hero center-s">{{ activeColourData?.label }}</p>
            </div>
        </ng-container>

    </div>

    <ng-container *ifSize="'MS'">
        <div class="center m-b"
             *ngIf="activeColourData?.copy || activeColourData?.ctaCopy">
            <p class="p1"
               *ngIf="activeColourData?.copy">{{ activeColourData?.copy }}</p>
            <button type="button"
                    class="button m-t-5"
                    *ngIf="activeColourData?.ctaCopy">
                <span>{{ activeColourData?.ctaCopy }}</span>
            </button>
        </div>
    </ng-container>

    <div [ngClass]="component.variant === 'image-above-text' ? 'c-12 center flex-x flex-l flex-m flex-column-x flex-column-l flex-column-m flex-middle-x flex-middle-l flex-middle-m' : 'c-3-x c-4-l c-5-m c-12-s'"
         [ngSwitch]="component.variant === 'image-above-text' && client.isS">

        <h2 sizeClass="S: h2, !S: h1"
            [ngClass]="component.variant === 'image-above-text' ? 'm-t-8 w-8 w-10-s' : 'm-t-12 m-t-0-s center p-r-8 p-r-14-s p-l-8 p-l-14-s'"
            *iCms="'title' of component">
        </h2>

        <p class="p1 center m-t-3"
           [ngClass]="component.variant === 'image-above-text' ? 'w-4 w-10-m w-11-s m-t-7-s' : 'p-r-5-s p-l-5-s'"
           *iCms="'subtitle' of component; skipEmpty: true">
        </p>

        <div class="center p-t p-t-5-s p-b-2"
             *ngIf="component.variant === 'side-by-side'">
            <div class="w-7 w-8-s b-b b-col-42"></div>
        </div>

        <div *ngSwitchDefault
             [ngClass]="component.variant === 'image-above-text' ? 'w-6 w-8-l w-11-m m-t-9' : 'flex-x flex-justify-center-x'">
            <div class="flex flex-wrap p-l-2-x p-l-1-l p-r-2-x p-r-1-l flex-justify-center color-swatch-box">
                <ng-container *ngFor="let swatch of component.colours; let i = index; trackBy: trackByIndex">
                    <ng-template
                                 *ngTemplateOutlet="buttonSwatch; context: { $implicit: swatch, index: i, isBig: component.variant === 'side-by-side', component: component }">
                    </ng-template>
                </ng-container>
            </div>
        </div>

        <swiper class="p-l-1 p-r-1 m-t"
                slidesPerView="5.5"
                *ngSwitchCase="true">
            <ng-container *ngFor="let swatch of component.colours; let i = index; trackBy: trackByIndex">
                <ng-template swiperSlide>
                    <ng-template
                                 *ngTemplateOutlet="buttonSwatch; context: { $implicit: swatch, index: i, component:component }">
                    </ng-template>
                </ng-template>
            </ng-container>
        </swiper>
    </div>
</div>

<ng-template #buttonSwatch
             let-swatch
             let-i="index"
             let-isBig="isBig">
    <div [ngClass]="component.variant === 'image-above-text' ? 'color-swatch-wrap' : ''">
        <div class="pos-relative inline-block _swatchContainer"
             (mouseenter)="changeActiveImage($event, i)"
             (mouseleave)="changeActiveImage($event, undefined)"
             (click)="changeActiveImage($event, i)"
             [ngClass]="component.variant === 'image-above-text' ? 'm-l-4 m-r-4 m-b-5 m-l-0-s m-r-0-s m-b-0-s' : 'm-l-1 m-r-1 m-b-2 m-b-3-s'">
            <swatch class="block"
                    [option]="swatch"
                    [selected]="selectedColorIndex === i"
                    [optionHuge]="isBig">
            </swatch>

            <div class="p-l-1 p-r-1 bg-col-43 col-w p2 color-tile__tooltip _tooltip center">{{ swatch.label }}</div>

            <span class="c1 italic pos-absolute pe-none new-label"
                  [ngClass]="swatch.new_copy_color"
                  *ngIf="swatch.new_copy">{{'New' | translate}}</span>

        </div>
    </div>
</ng-template>